import { Tag } from '@cian/components';
import * as React from 'react';

import { EWCType } from '../../../../json_query';
import { IWCTypeTag } from '../../../state/tags/definitions/wc_type';
import { TagNew } from '../TagNew';

import { tagThemeSmall } from '../tag_theme';

export interface IWCTypeTagItemProps {
  tag: IWCTypeTag;
  withNewTag?: boolean;
  onDeleteClick(): void;
}

const wcTypeMap = {
  [EWCType.Separated]: 'Раздельный',
  [EWCType.United]: 'Совмещенный',
};

export const WCTypeTagItem = ({ tag, onDeleteClick, withNewTag }: IWCTypeTagItemProps) => {
  const TagComponent = React.useMemo(() => (withNewTag ? TagNew : Tag), [withNewTag]);

  if (tag.value === EWCType.Any) {
    return null;
  }

  return (
    <TagComponent onDeleteClick={onDeleteClick} tagStyles={tagThemeSmall}>
      {wcTypeMap[tag.value]} санузел
    </TagComponent>
  );
};
